export default __webpack_public_path__ + "src/images/packages/maison-de-plage/92fee7ec2b40f87ddd0e4c0c8ae74d22-5.jpg";